import { render, staticRenderFns } from "./DeanEdit.vue?vue&type=template&id=c1dbf9ac&scoped=true&"
import script from "./DeanEdit.vue?vue&type=script&lang=js&"
export * from "./DeanEdit.vue?vue&type=script&lang=js&"
import style0 from "./DeanEdit.vue?vue&type=style&index=0&id=c1dbf9ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dbf9ac",
  null
  
)

export default component.exports